import { render, staticRenderFns } from "./secondLevelList.vue?vue&type=template&id=2c0900e5&scoped=true"
import script from "./secondLevelList.vue?vue&type=script&lang=js"
export * from "./secondLevelList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/course/secondLevelList.css?vue&type=style&index=0&id=2c0900e5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0900e5",
  null
  
)

export default component.exports